module.exports = __webpack_public_path__ + "img/hover_icon_compensatory_service.9723cd1f.svg";